import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Rightcontainer from "../Components/Rightcontainer";
import "../css/layout.css";
import "../css/login.css";
import findGif from "../css/loading_old.gif";
import Spinner from "react-bootstrap/Spinner";
import { apiRequest } from "../store/allApi";

export default function Login() {
  const history = useHistory();
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++

  const { referralcode } = useParams();

  const [Phone, setPhone] = useState();
  const [twofactor_code, settwofactor_code] = useState();
  const [otp, setOtp] = useState(false);
  const [isLoading1, setIsloading1] = useState(false);
  const [secretCode, setSecretCode] = useState();

  let refs = useLocation().pathname.split("/")[2];
  const [referral, setReferral] = useState(refs);

  const [receivedOTP, setReceivedOTP] = useState("");

  const fetchData = async () => {
    if ("OTPCredential" in window) {
      const ac = new AbortController();
      try {
        const otpCredential = await navigator.credenstials?.get({
          otp: { transport: ["sms"] },
          signal: ac.signal,
        });
        setReceivedOTP(otpCredential?.code);
        ac.abort();
      } catch (err) {
        ac.abort();
        console.log(err);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleClick = async (e) => {
    e.preventDefault();
    if (!Phone) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter your phone number",
      });
    } else if (Phone.length != 10) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please  enter currect phone number",
      });
    } else {
      setIsloading1(true);
      const time = new Date();
      let newTime = time.toString();

      try {
        const respone = await apiRequest(
          `login`,
          "POST",
          { Phone, referral, newTime },
          null,
        );
        if (respone) {
          setIsloading1(false);
          if (respone.data.status == 101) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: respone.data.msg,
            });
          } else if (respone.data.status == 200) {
            setOtp(true);
            setSecretCode(respone.data.secret);
            if (respone.data.myToken) {
              Swal.fire({
                icon: "success",
                title: "OTP",
                text: "Demo Account Testing OTP: " + respone.data.myToken,
              });
            }
          } else if (respone?.data?.status == false) {
            Swal.fire({
              icon: "error",
              text: respone?.data?.msg,
            });
          }
        }
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
        });
      }
    }
  };

  const varifyOtp = async (e) => {
    e.preventDefault();

    if (!Phone) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter your phone number",
      });
      return;
    }

    setIsloading1(true);

    try {
      const response = await apiRequest(
        `login/finish`,
        "POST",
        { Phone, twofactor_code, referral, secretCode },
        null,
      );
      setIsloading1(false);

      if (response.data.status === 101) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.data.msg,
        });
      } else if (response.data.status === 200) {
        const token = response.data.token;
        localStorage.setItem("token", token);
        // Reload the page and redirect after a delay
        setTimeout(() => {
          window.location.reload(true);
          history.push("/Games"); // Assuming you have 'history' available
        }, 1000);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    } catch (error) {
      setIsloading1(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  // otp valid
  const [isValid, setIsValid] = useState(false);
  const [showResend, setShowResend] = useState(false);
  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    let timerInterval;

    if (isValid && seconds > 0) {
      timerInterval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
    } else {
      clearInterval(timerInterval);
      setShowResend(true); // Show the Resend button when OTP expires
      setIsValid(false);
    }

    return () => {
      clearInterval(timerInterval);
    };
  }, [isValid, seconds]);

  const handleResendClick = (e) => {
    handleClick(e);
    setIsValid(true);
    setSeconds(60);
    setShowResend(false); // Hide the Resend button after clicking it
  };
  return (
    <>
      <div className="leftContainer" style={{ minHeight: "100vh" }}>
        <div className="auth-master-wrapper">
          {/* Dynamic Background Elements */}
          <div className="glow-orb orb-top"></div>
          <div className="glow-orb orb-bottom"></div>

          <div className="auth-container">
            <div className="auth-card-premium">
              {/* Brand Identity */}
              <div className="auth-brand">
                <div className="logo-ring">
                  <img src="/logo.jpg" className="auth-logo" alt="rkwinzo" />
                </div>
                <h1 className="auth-title">rkwinzo</h1>
                <p className="auth-subtitle">The Ultimate Gaming Arena</p>
              </div>

              {/* Input Section */}
              <div className="auth-form-body">
                <label className="input-label">Mobile Number</label>
                <div className="modern-input-box mb-3">
                  <span className="country-tag">+91</span>
                  <input
                    className="clean-input"
                    name="mobile"
                    type="tel"
                    maxLength="10"
                    placeholder="Enter 10 digit number"
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>

                {otp && (
                  <div className="otp-entry-section animate-slide-up">
                    <label className="input-label mt-3">OTP Verification</label>
                    <div className="modern-input-box otp-focus">
                      <input
                        className="clean-input text-center letter-spacing-lg"
                        name="password"
                        type="tel"
                        placeholder="------"
                        onChange={(e) => settwofactor_code(e.target.value)}
                      />
                    </div>

                    <div className="otp-meta">
                      {isValid || seconds !== 0 ? (
                        <p className="timer-text">
                          Request new code in <span>{seconds}s</span>
                        </p>
                      ) : (
                        showResend && (
                          <button
                            className="resend-link"
                            onClick={handleResendClick}
                          >
                            RESEND OTP
                          </button>
                        )
                      )}
                    </div>
                  </div>
                )}

                {/* Action Buttons */}
                <div className="auth-action-row">
                  {!otp ? (
                    <button
                      className={`elite-btn ${isLoading1 ? "btn-loading" : ""}`}
                      disabled={isLoading1}
                      onClick={(e) => {
                        handleClick(e);
                        setIsValid(true);
                      }}
                    >
                      {isLoading1 ? (
                        <div className="spinner-border-sm"></div>
                      ) : (
                        "GET OTP"
                      )}
                    </button>
                  ) : (
                    <button
                      className={`elite-btn verify-mode ${isLoading1 ? "btn-loading" : ""}`}
                      disabled={isLoading1}
                      onClick={(e) => varifyOtp(e)}
                    >
                      {isLoading1 ? "VERIFYING..." : "START PLAYING"}
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* Responsive Footer */}
            <footer className="auth-footer-v3">
              <div className="footer-links-grid">
                <Link to="/about">About</Link>
                <Link to="/Terms">Privacy</Link>
                <Link to="/term-condition">Terms</Link>
                <Link to="/RefundPolicy">Refund</Link>
              </div>
              <p className="footer-disclaimer">
                ⚠️ 18+ Only. This game involves financial risk. Restricted in:
                AS, OR, NG, SK, MH, AP, TS.
              </p>
            </footer>
          </div>
        </div>
      </div>
    </>
  );
}
